module.exports = __webpack_public_path__ + "img/monitor.f341be60.svg";